import { Link } from 'react-router-dom'
import styles from './CategoryDropdown.module.scss'

const CategoryList = ({ categories, onClose }: { categories: any[], onClose?: () => void }) => {
  if (!categories) return null

  return (
    <>
      {categories.map(category => (
        <div className={styles.categoryColumn} key={category.id}>
          <Link
            onClick={onClose}
            to={`/products?categoryId=${category.id}`}
            className={styles.categoryTitle}
          >
            {category.name}
          </Link>

          {category.children?.map((group: any) => (
            <div className={styles.subcategoryGroup} key={group.id}>
              <Link
                onClick={onClose}
                to={`/products?categoryId=${group.id}&parent_id=${category.id}`}
                className={styles['subcategoryGroup-title']}
              >
                {group.name}
              </Link>

              {group.children?.map((sub: any) => (
                <Link
                  to={`/products?categoryId=${sub.id}`}
                  className={styles['subcategoryGroup-item']}
                  onClick={onClose}
                  key={sub.id}
                >
                  {sub.name}
                </Link>
              ))}
            </div>
          ))}
        </div>
      ))}
    </>
  )
}

export default CategoryList
